jQuery(document).ready(function () {
  const swiper = new Swiper(".recommandproduct-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".recommandproduct-slider-Next",
      prevEl: ".recommandproduct-slider-Prev",
    },
    pagination: {
      el: ".recommandproduct-pagination",
      clickable: true,
    },
  });

  initCartProductsSwiper();
});

function initCartProductsSwiper() {
  const container = document.querySelector(".cartproducts-slider");
  if (container) {
    // Destroy if already initialized
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    new Swiper(".cartproducts-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".cartproducts-slider-Next",
        prevEl: ".cartproducts-slider-Prev",
      },
      pagination: {
        el: ".cartproducts-pagination",
        clickable: true,
      },
    });
  }
}

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(/[^\d.-]/g, "");
    cents = parseFloat(cents);
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number == null) return "0";

    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
    var cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  var match = format && format.match(placeholderRegex);
  if (!match) return cents;

  switch (match[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return format.replace(placeholderRegex, value);
}

$(document).on("change", ".quantity__input", function () {
  var value = $(this).val(),
    price = $(this).attr("data-price"),
    totalPrice = parseInt(price) * parseInt(value);

  var formatString = window.shopMoneyFormat || "{{amount}}";
  var formattedPrice = formatMoney(totalPrice, formatString);
  $(".price-custom-change").text(formattedPrice);
});

$(document).on("click", ".pack-option", function () {
  var value = $(".quantity__input").val(),
    price = $(this).attr("data-price"),
    totalPrice = parseInt(price) * parseInt(value);

  $(document).find(".price-custom-change").text(price);
});

jQuery(document).ready(function ($) {
  var menuTimer;

  $(".mega-menu > summary").on("click", function (e) {
    e.preventDefault();
  });

  $(".mega-menu").on("mouseenter", function () {
    clearTimeout(menuTimer);
    $(this).attr("open", true);
  });

  $(".mega-menu").on("mouseleave", function () {
    var $menu = $(this);
    menuTimer = setTimeout(function () {
      $menu.removeAttr("open");
    }, 200);
  });

  var hoverTimer;

  $("header-menu details > summary").on("click", function (e) {
    e.preventDefault();
  });

  $("header-menu details").on("mouseenter", function () {
    clearTimeout(hoverTimer);
    $(this).attr("open", true);
  });

  $("header-menu details").on("mouseleave", function () {
    var $this = $(this);
    hoverTimer = setTimeout(function () {
      $this.removeAttr("open");
    }, 200);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("summary a").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  });
});

function setDeliveryDate(forceUpdate = false) {
  const cutoffHour = 13;
  const deliveryDays = [
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
  ];
  const monthNames = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();

  let deliveryDate = new Date();

  const addDays = (days) => deliveryDate.setDate(deliveryDate.getDate() + days);

  if (day === 5) {
    addDays(3);
  } else if (day === 6 || day === 0) {
    addDays(2);
  } else {
    if (hour < cutoffHour) {
      addDays(1);
    } else {
      addDays(day === 4 ? 2 : 2);
    }
  }

  const deliveryDayName = deliveryDays[deliveryDate.getDay()];
  const deliveryDateNumber = ("0" + deliveryDate.getDate()).slice(-2);
  const deliveryMonthName = monthNames[deliveryDate.getMonth()];
  const deliveryText = `${deliveryDayName} ${deliveryDateNumber} ${deliveryMonthName}`;

  document.querySelectorAll(".deliverydatebox span").forEach((span) => {
    if (forceUpdate || !span.textContent.trim()) {
      span.textContent = deliveryText;
    }
  });
}

function setupCartDrawerHook() {
  const drawerSelector = "cart-drawer, #CartDrawer, .cart-drawer";
  let lastHTML = "";
  let retry = 0;

  const pollDOM = setInterval(() => {
    const drawer = document.querySelector(drawerSelector);
    if (drawer) {
      const htmlNow = drawer.innerHTML;
      if (htmlNow !== lastHTML) {
        lastHTML = htmlNow;
        setDeliveryDate(true);
        initCartProductsSwiper(); // ✅ Re-initialize cart product slider
      }
    }
    retry++;
    if (retry > 60) clearInterval(pollDOM);
  }, 500);
}

document.addEventListener("DOMContentLoaded", function () {
  setDeliveryDate(true);

  let tries = 0;
  const safeRetry = setInterval(() => {
    setDeliveryDate(true);
    tries++;
    if (tries > 20) clearInterval(safeRetry);
  }, 500);

  setupCartDrawerHook();
});
function updateCartButtonPrice() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Shopify already returns discounted total in total_price
        let finalPrice = cart.total_price / 100; 
        let currency = Shopify.currency.active;

        // Format currency
        let formattedPrice = new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: currency
        }).format(finalPrice);

        // 2026-07-18 : plus rien à réécrire ici. Le montant du bouton est déjà
        // rendu par Liquid et régénéré par Shopify à chaque mise à jour du tiroir.
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  /*
   * ⛔ POLLING SUPPRIMÉ (2026-07-18) — NE PAS LE REMETTRE.
   * Ce code appelait /cart.js TOUTES LES 1,5 SECONDES, sur toutes les pages et en
   * permanence, dans le seul but de réécrire le montant du bouton de commande :
   * ~40 requêtes par minute et par visiteur.
   * Conséquences observées : rafales de `cart.js` dans l'onglet Réseau, erreurs
   * « Cart fetch error » en console, et très probablement les blocages 429
   * (limitation anti-abus de Shopify) rencontrés pendant les tests.
   * Inutile de surcroît : le montant du bouton est écrit par Liquid
   * ({{ cart.total_price }}) et Shopify régénère la section du tiroir à chaque
   * modification du panier — l'affichage reste donc juste sans aucun polling.
   */


document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('cart-drawer');
  const overlay = document.querySelector('#CartDrawer-Overlay');

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (cartDrawer.classList.contains('active')) {
        // Scroll disable
        document.body.classList.add('no-scroll');
        document.documentElement.classList.add('no-scroll');
      } else {
        // Scroll enable
        document.body.classList.remove('no-scroll');
        document.documentElement.classList.remove('no-scroll');
      }
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (overlay) {
    overlay.addEventListener('click', () => {
      document.body.classList.remove('no-scroll');
      document.documentElement.classList.remove('no-scroll');
    });
  }
});



